var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-height-layout fill"},[_c('router-view',{ref:"routeview"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }